const FINAL_TO_REGULAR: Record<string, string> = {
  'ן': 'נ', 'ם': 'מ', 'ף': 'פ', 'ץ': 'צ', 'ך': 'כ',
};

export const normalizeFinals = (text: string): string =>
  text.replace(/[ןםףץך]/g, letter => FINAL_TO_REGULAR[letter]);

export const stripNiqqud = (text: string): string => text.replace(/[֑-ׇ]/g, '');

// Letters and digits only, with niqqud removed and final letters converted.
// Two answers with the same key are the same answer for duplicate checks.
export const compareKey = (text: string): string =>
  normalizeFinals(stripNiqqud(text))
    .toUpperCase()
    .replace(/[^א-תA-Z0-9]/g, '');

export const uniqueLetterCount = (text: string): number =>
  new Set(compareKey(text).replace(/[0-9]/g, '').split('')).size;
